import { create } from "zustand";

export type TNotificationType = "chat_responded" | "project_ready";

export type TNotification = {
  id: number;
  type: TNotificationType;
  isRead: boolean;
  projectId: number | null;
  userId: number;
  createdAt: string;
  updatedAt: string;
  project: {
    id: number;
    name: string;
  } | null;
};

type TNotificationStore = {
  notifications: TNotification[];

  setNotifications: (notifications: TNotification[]) => void;
  addNotification: (notification: TNotification) => void;
  removeProjectNotifications: (projectId: number) => void;
};

export const useNotificationStore = create<TNotificationStore>((set, get) => ({
  notifications: [],

  setNotifications: (notifications: TNotification[]) => {
    set({ notifications });
  },

  addNotification: (notification: TNotification) => {
    if (get().notifications.some((n) => n.id === notification.id)) {
      return;
    }
    set({ notifications: [notification, ...get().notifications] });
  },

  removeProjectNotifications: (projectId: number) => {
    set({
      notifications: get().notifications.filter((n) => (n.projectId ?? n.project?.id) !== projectId)
    });
  }
}));
